import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (walletAccounts, get, multipleWalletAccountsEnabled) => {
    const enabledAccounts = walletAccounts.filter((walletAccount) => get(walletAccount)?.enabled);
    return multipleWalletAccountsEnabled === false ? enabledAccounts.slice(0, 1) : enabledAccounts;
};
export default defineSelectorResultFunction({
    id: 'enabled',
    resultFunction,
    dependencies: [
        { selector: 'names' },
        { selector: 'get' },
        { selector: 'multipleWalletAccountsEnabled' },
    ],
});
